import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BaseComponent, WmsToggleComponent, WmsMessageComponent } from '@wms/app/components';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { SecurityService, DatabaseComponent } from '@wms/settings/security';
import { get, includes, isEqual } from 'lodash-es';
import { WmHttpService } from '@wms/app/services';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-active-directory',
  templateUrl: './active-directory.component.html',
  styleUrls: ['./active-directory.component.less'],
  imports: [CommonModule, FormsModule, WmsToggleComponent, WmsMessageComponent, DatabaseComponent]
})
export class ActiveDirectoryComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  securityService: SecurityService;
  security: any;
  hideMessage: boolean = true;
  formChangesSubscription: Subscription;
  resetFormSubscription: Subscription;
  message: any;
  @ViewChild('adForm', { static: true }) ngForm: NgForm;

  constructor(private httpService: WmHttpService) {
    super();
    this.securityService = inject(SecurityService);
  }

  ngOnInit(): void {
    this.security = this.securityService.security;
    this.security.userADRoleProviders = ['Active Directory', 'Database'];
    let setInitialValue: boolean = true;
    if (this.securityService.adFormInitialValue) {
      setInitialValue = false;
      setTimeout(() => {
        this.ngForm.form.patchValue(this.securityService.adFormInitialValue);
      });
    }

    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(val => {
      if (!this.ngForm.form.dirty && setInitialValue) {
        this.securityService.adFormInitialValue = this.ngForm.form.value;
      }
      if (this.ngForm.form.dirty) {
        if (isEqual(this.securityService.adFormInitialValue, this.ngForm.form.value)) {
          this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('adProvider', 1));
        } else if (!includes(this.security.dirtyCheckList, 'adProvider')) {
          this.security.dirtyCheckList.push('adProvider');
        }
      }
    });


    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.ngForm.form.reset(this.securityService.adFormInitialValue);
      } else {
        this.securityService.adFormInitialValue = this.ngForm.form.value;
      }
    });
    if (this.security.enableSecurity) {
      //hiding error messages if any, since provider was changed
      this.hideMessage = true;
    }
    this.securityService.getActiveDirectoryOptions(this.authInfo);
    this.security.showUnamePass = false;
    // TODO
    // this.handleWatchers(provider);
    //don't initialize if 'prevProvider' is same as 'provider'
    if (this.securityProps.prevProvider === 'AD') {
      return;
    }

  }

  onConfigChange() {
    this.securityService.configurationDetailsChanged = true;
  }

  testActiveDirConnection() {
    this.hideMessage = true;

    if (!this.security.enableSecurity) {
      return;
    }
    if (!this.security.url || !this.security.url.trim()) {
      this.hideMessage = false;
      this.message = {
        type: 'error',
        'caption': this.locale.MESSAGE_AD_URL_NOT_SET
      };
    } else if (!this.security.rootDn || !this.security.rootDn.trim()) {
      this.hideMessage = false;
      this.message = {
        type: 'error',
        'caption': this.locale.MESSAGE_ROOT_DN_NOT_SET
      };
    } else if (!this.security.userSearchPattern || !this.security.userSearchPattern.trim()) {
      this.hideMessage = false;
      this.message = {
        type: 'error',
        'caption': this.locale.MESSAGE_USER_SEARCH_PATTERN_NOT_SET
      };
    } else if (!this.security.managerDn || !this.security.managerDn.trim()) {
      this.hideMessage = false;
      this.message = {
        type: 'error',
        'caption': this.locale.MESSAGE_TEST_USERNAME_NOT_SET
      };
    } else if (!this.security.managerPassword) {
      this.hideMessage = false;
      this.message = {
        type: 'error',
        'caption': this.locale.MESSAGE_TEST_USER_PWD_NOT_SET
      };
    }

    if (!this.hideMessage) {
      return;
    }

    this.hideMessage = false;
    this.message = {
      type: 'loading',
      'caption': this.locale.MESSAGE_TESTING_CONNECTION
    };

    (this.securityService.testADConnection({
      config: {
        'url': this.security.url,
        'domain': this.security.domain,
        'rootDn': this.security.rootDn,
        'userSearchPattern': this.security.userSearchPattern,
        'testUsername': this.security.managerDn,
        'testPassword': this.security.managerPassword
      }
    }) as Promise<any>).then(() => {
      this.hideMessage = false;
      this.message = {
        type: 'success',
        'caption': this.locale.MESSAGE_CONNECTION_SUCCESSFUL
      };
      this.security.isConncetionTested = true;
      this.securityService.configurationDetailsChanged = false;
    }).catch((errMsg) => {
      let errorObj = get(errMsg, 'error.errors.error[0]');
      this.hideMessage = false;
      this.message = {
        type: 'error',
        caption: this.httpService.parseError(errorObj)
      };
    });
  }

  override ngOnDestroy(): void {
    this.formChangesSubscription?.unsubscribe();
    this.resetFormSubscription?.unsubscribe();
  }
}
